import * as buttons from 'smg/buttons';
import { CreateUser, SetPasswordOnLogin } from 'smg/customer-api/v2/users';
import { ReportValidity } from 'smg/form';

import { Phone } from 'smg/phone';
import { AfterLoginPath, CarryReturn, PromptLoginCode } from '../login-code';

main();

function main() {
    CarryReturn();

    const $firstName = document.querySelector('#first-name') as HTMLInputElement;
    const $lastName = document.querySelector('#last-name') as HTMLInputElement;
    const $company = document.querySelector('#company') as HTMLInputElement;
    const $email = document.querySelector('#email') as HTMLInputElement;
    const $phone = document.querySelector('#phone') as HTMLInputElement;
    const $password = document.querySelector('#password') as HTMLInputElement;
    const $confirmPassword = document.querySelector('#confirm-password') as HTMLInputElement;
    const $form = document.querySelector('#register-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;
    const $submit = $form.querySelector('[type="submit"]') as HTMLButtonElement;
    const $alert = $form.querySelector('.alert') as HTMLElement;
    const $header = document.querySelector('.register-title') as HTMLElement;

    // Remove alert from DOM, keep reference for cloning
    $alert.parentElement?.removeChild($alert);
    $alert.classList.remove('d-none');

    const showAlert = () => {
        hideAlert();
        const $a = $alert.cloneNode(true) as HTMLElement;
        const $msg = $a.querySelector('.generic');
        $msg?.classList.remove('d-none');
        $header.after($a);
    };

    const hideAlert = () => {
        const $a = document.querySelector('.register-page .alert');
        $a?.parentElement?.removeChild($a);
    };

    const p = new Phone($phone);

    // Confirm password validation
    $confirmPassword.addEventListener('input', () => {
        if ($confirmPassword.value && $confirmPassword.value !== $password.value) {
            $confirmPassword.setCustomValidity('Passwords do not match');
        } else {
            $confirmPassword.setCustomValidity('');
        }
    });
    $password.addEventListener('input', () => {
        if ($confirmPassword.value && $confirmPassword.value !== $password.value) {
            $confirmPassword.setCustomValidity('Passwords do not match');
        } else {
            $confirmPassword.setCustomValidity('');
        }
    });

    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return false;
        }

        hideAlert();

        $fieldset.setAttribute('disabled', 'disabled');
        buttons.Start($submit);

        const emailAddress = $email.value;
        const passwordValue = $password.value;
        const phoneValue = await p.format();
        CreateUser({
            'firstName': $firstName.value,
            'lastName': $lastName.value,
            'company': $company.value,
            'emailAddress': { 'email': emailAddress },
            'phoneNumber': phoneValue !== '' ? { 'phone': phoneValue } : undefined,
        }).then(async () => {
            const prompt = SetPasswordOnLogin(await PromptLoginCode({ email: emailAddress }), passwordValue);

            void prompt.createCode.finally(() => {
                $fieldset.removeAttribute('disabled');
                buttons.Stop($submit);
            });

            prompt.login.
                then(() => {
                    window.location.href = AfterLoginPath();
                }).
                catch(err => {
                    showAlert();
                    throw err;
                });
        }).catch(() => {
            $fieldset.removeAttribute('disabled');
            buttons.Stop($submit);
            showAlert();
        });
    });
}
